/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ChainlinkL1Fake } from "./ChainlinkL1Fake";

export class ChainlinkL1FakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ChainlinkL1Fake> {
    return super.deploy(overrides || {}) as Promise<ChainlinkL1Fake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ChainlinkL1Fake {
    return super.attach(address) as ChainlinkL1Fake;
  }
  connect(signer: Signer): ChainlinkL1FakeFactory {
    return super.connect(signer) as ChainlinkL1FakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ChainlinkL1Fake {
    return new Contract(address, _abi, signerOrProvider) as ChainlinkL1Fake;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "priceFeedL2",
        type: "address",
      },
    ],
    name: "PriceFeedL2Changed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "messageId",
        type: "bytes32",
      },
    ],
    name: "PriceUpdateMessageIdSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint80",
        name: "roundId",
        type: "uint80",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "PriceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rootBridge",
        type: "address",
      },
    ],
    name: "RootBridgeChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_aggregator",
        type: "address",
      },
    ],
    name: "addAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getAggregator",
    outputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rootBridge",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceFeedL2",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_number",
        type: "uint256",
      },
    ],
    name: "mock_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "mock_setBlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "prevTimestampMap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "priceFeedKeys",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeedL2Address",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "priceFeedMap",
    outputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "removeAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rootBridge",
    outputs: [
      {
        internalType: "contract RootBridge",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_priceFeedL2",
        type: "address",
      },
    ],
    name: "setPriceFeedL2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rootBridge",
        type: "address",
      },
    ],
    name: "setRootBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "updateLatestRoundData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
